import AuthLayout from "../../containers/auth";
import { useState } from "react";
import toast from "react-hot-toast";
import api from "../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import fPass from "../../assets/fpass.svg";
import msg from "../../assets/msg.svg";
import codeIcon from "../../assets/code.svg";

const ForgotPass = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [isVerifyingCode, setIsVerifyingCode] = useState(false);

  const navigate = useNavigate();

  const handleGetResetCode = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Email is required");
      return;
    }
    setIsSendingCode(true);
    try {
      const response = await api.post("/auth/send-reset-code", { email });
      if (response.status === 200) {
        setCodeSent(true);
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    } finally {
      setIsSendingCode(false);
    }
  }

  const handleResendCode = async (e) => {
    e.preventDefault();
    setIsSendingCode(true);
    try {
      const response = await api.post("/auth/send-reset-code", { email });
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    } finally {
      setIsSendingCode(false);
    }
  }

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    if (!email || !code) {
      toast.error("Email and code are required");
      return;
    }

    setIsVerifyingCode(true);
    try {
      const response = await api.post("/auth/verify-reset-code", { email, code });
      if (response.status === 200) {
        localStorage.setItem("resetEmail", email);
        toast.success(response.data.message);
        navigate("/auth/reset-password");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    } finally {
      setIsVerifyingCode(false);
    }
  }
  
  return (
    <AuthLayout imageSrc={fPass}>
      <h2 className="mb-2 text-2xl   font-bold text-secondary text-center">
        Quick Reset, Big Wins –{" "}
        <span className="block">Retrieve Your Password! </span>
      </h2>
      <p className="mb-6 text-sm text-gray-600 text-center">
        Enter your email address and we will send you a verification code to
        reset your password.
      </p>
      <form className="w-full max-w-sm">
        <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2">
          <img src={msg} alt="msg-icon"></img>
          <input
            type="email"
            placeholder="Email Address"
            className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="flex gap-4">
          <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2">
            <img src={codeIcon} alt="lock-icon"></img>
            <input
              type="text"
              placeholder="Code"
              className="ml-2 flex-1  border-none bg-transparent text-accent outline-none py-2 px-4"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          {codeSent ? (
            <button
              className="mb-4   rounded-2xl border-2 border-secondary p-2"
              onClick={handleResendCode}
            >
              Resend Code
            </button>
          ) : (
            <button
              className="mb-4   rounded-2xl border-2 border-secondary p-2"
              onClick={handleGetResetCode}
            >
              {isSendingCode ? "Sending..." : "Get Code"}
            </button>
          )}
        </div>

        <button 
          className="w-full rounded-2xl bg-primary text-white py-3 font-bold hover:bg-opacity-90"
          onClick={handleVerifyCode}
          disabled={isVerifyingCode}
        >
          Continue
        </button>

        <p className="mt-4 text-center text-sm text-gray-600">
          <Link to="/auth/signin" className=" text-secondary hover:underline">
            Back to Log in
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
};

export default ForgotPass;
